import styled from 'styled-components';
import SVG from 'assets/svgs';
import { fontXSContrast, fontXS, fontXXS } from 'styles/jakarta';
import { DESKTOP } from 'containers/landing/breakpoints';
import Link from 'components/link';

const SCREEN_MAX_WIDTH = '1000px';

export const Section = styled.div`
  display: flex;
  margin-bottom: 24px;
  flex-direction: column;
`;

export const FooterWrapper = styled.div`
  padding: 24px 16px;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.subContent};
  display: flex;
  flex-direction: column;

  @media (min-width: ${DESKTOP}) {
    padding: 56px 34px;
    max-width: ${SCREEN_MAX_WIDTH};
    margin: 0 auto;
  }

  @media (min-width: ${SCREEN_MAX_WIDTH}) {
    padding: 56px 64px;
  }
`;

export const SubHeader = styled.div`
  ${fontXSContrast};
`;

export const LinksSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  div {
    margin-bottom: 7px;
  }
`;

export const LinkButton = styled.button`
  border: none;
  background-color: transparent;
  text-align: left;
  padding: 0;
  cursor: pointer;
  ${fontXS};
  color: ${({ theme }) => theme.subContent};
  margin-bottom: 7px;
  margin-left: 0;
`;

export const StyledLink = styled.a`
  cursor: pointer;
  ${fontXS};
  color: ${({ theme }) => theme.subContent};
  margin-bottom: 7px;
`;

export const LinksWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 24px;

  @media (min-width: ${DESKTOP}) {
    margin-bottom: 36px;
  }
`;

export const Icon = styled(SVG)`
  fill: ${({ theme }) => theme.subContent};
  height: 24px;
  width: 24px;
`;

export const PayPalIcon = styled.div`
  padding-left: 16px;
`;

export const SSLSecuredWrapper = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 15px;
    ${fontXSContrast};
  }
`;

export const Paragraph = styled.p`
  margin-top: 8px;
  ${fontXXS};
`;

export const SocialsLink = styled.a`
  padding: 8px;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${DESKTOP}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const RightsReservedWrapper = styled(Section)`
  margin-bottom: 0;
  @media (min-width: ${DESKTOP}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const SocialsSection = styled(Section)`
  justify-self: flex-end;
`;

export const FAQLink = styled(Link)`
  ${fontXS};
  color: ${({ theme }) => theme.subContent};
  text-decoration: none;
  :focus,
  :hover {
    text-decoration: none;
  }
  :visited {
    color: ${({ theme }) => theme.subContent};
  }
  margin-bottom: 7px;
`;
